//  TODO: move this file into shared/vulns/
// The order of these keys are how they appear in the UI
export const CveDisputeReasons = {
  falsePositive: 'Vulnerability false positive',
  incorrectNextSafeVersion: 'Incorrect remediation suggestion',
  incorrectVersionReported: 'Incorrect dependency version reported',
} as const;

export type CveDataDisputeReasonsKey = keyof typeof CveDisputeReasons;
export type CveDataDisputeReasonsType = typeof CveDisputeReasons[keyof typeof CveDisputeReasons];
